import { Link } from "react-router-dom";
import { Button } from "./ui/button";

export default function BrandHeader({ compact = false }) {
  return (
    <header className="sticky top-0 z-50 border-b border-slate-200 bg-white/85 backdrop-blur-xl" data-testid="site-header">
      <div className="mx-auto flex w-full max-w-[1700px] items-center justify-between gap-4 px-4 py-4 sm:px-6 lg:px-8">
        <Link to="/" className="flex items-center gap-3 no-underline" data-testid="brand-home-link">
          <div>
            <p className="font-[Outfit] text-2xl font-black tracking-tight text-[#A31D2F] sm:text-3xl">CSR Insights</p>
            <p className="text-xs font-semibold uppercase tracking-[0.24em] text-slate-500">by Dhwani RIS</p>
          </div>
        </Link>

        <div className="flex items-center gap-3">
          {compact ? (
            <div className="flex items-center gap-3">
              <Link to="/" data-testid="header-primary-link">
                <Button className="rounded-none bg-[#F26522] px-5 py-3 font-bold text-white hover:bg-[#D9561B]" data-testid="header-primary-button">
                  Back to explorer
                </Button>
              </Link>
            </div>
          ) : (
            <div className="flex items-center gap-3">
              <a href="#explorer-controls" data-testid="header-primary-link">
                <Button className="rounded-none bg-[#F26522] px-5 py-3 font-bold text-white hover:bg-[#D9561B]" data-testid="header-primary-button">
                  Start exploring
                </Button>
              </a>
            </div>
          )}
        </div>
      </div>
    </header>
  );
}